import { i18n } from '@lingui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { mapTools } from '../../../constants/variables';
import styles from './MapControls.module.css';
import { useState, useEffect } from 'react';

export const MapControls = ({
    onToggleToolButton,
    activeTools,
}) => {
    const [ isMobileMenu, setIsMobileMenu ] = useState(window.innerWidth <= 850);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileMenu(window.innerWidth <= 850);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isMobileMenu) {
        // На мобильных скрываем инструменты - они ненужны
        return null;
    }

    return (
        <ButtonGroup
            className={styles.controlsWrapper}
            variant='contained'
            size='small'
        >
            {
                mapTools.map(({ type, label }) => (
                    <Button
                        key={type}
                        onClick={() => onToggleToolButton(type)}
                        color={activeTools.includes(type) ? 'primary' : 'default'}
                    >
                        {i18n._(label)}
                    </Button>
                ))
            }

        </ButtonGroup>
    );
};
